const emptyObject = ()=> []
const state = emptyObject()


// actions
const actions = {}

export default {
  emptyObject,
}